import { styled } from 'linaria/react';

export const StyledSection = styled.section`
  padding: 16px 12px 0;
`;
